import { useLang } from "@/lib/i18n";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center border border-white/10 font-mono text-[10px] ${className}`} data-testid="lang-switcher">
      <button
        onClick={() => setLang("pt")}
        className={`px-2 py-1 transition ${lang === "pt" ? "bg-white/10 text-white" : "text-white/40 hover:text-white"}`}
        data-testid="lang-pt"
      >PT</button>
      <button
        onClick={() => setLang("en")}
        className={`px-2 py-1 transition ${lang === "en" ? "bg-white/10 text-white" : "text-white/40 hover:text-white"}`}
        data-testid="lang-en"
      >EN</button>
      <button
        onClick={() => setLang("es")}
        className={`px-2 py-1 transition ${lang === "es" ? "bg-white/10 text-white" : "text-white/40 hover:text-white"}`}
        data-testid="lang-es"
      >ES</button>
    </div>
  );
}
